import { render, staticRenderFns } from "./disable.vue?vue&type=template&id=4c6ae4e5&scoped=true&"
import script from "./disable.vue?vue&type=script&lang=ts&"
export * from "./disable.vue?vue&type=script&lang=ts&"
import style0 from "./disable.vue?vue&type=style&index=0&id=4c6ae4e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ae4e5",
  null
  
)

export default component.exports